import { CatalogScreen } from "@commerce/catalog/CatalogScreen";
import { catalogSearchSchema } from "@commerce/catalog/search-params";
import { LoadingRegion } from "@commerce/components/page";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { orpc } from "@shared/lib/orpc";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/catalog",
)({
	validateSearch: catalogSearchSchema,
	// Sources and sync used to be a tab here.
	beforeLoad: ({ search, params }) => {
		if (search.tab === "sources") {
			throw redirect({
				to: "/app/$organizationSlug/sources",
				params,
				search: search.run ? { run: search.run } : {},
				replace: true,
			});
		}
	},
	// Filters and paging are client queries; the loader only warms the header.
	shouldReload: false,
	loader: async ({ context }) => {
		const organizationId = context.organization.id;
		const queryClient = getServerQueryClient();
		await queryClient.ensureQueryData(
			orpc.catalog.overview.queryOptions({ input: { organizationId } }),
		);
		return {
			organizationId,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({ meta: [{ title: `Products - ${config.appName}` }] }),
	component: CatalogPage,
});

function CatalogPage() {
	const { organizationId, dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={
				<LoadingRegion
					label="Loading products"
					className="min-h-[50svh]"
				/>
			}
			dehydratedState={dehydratedState}
		>
			<CatalogScreen organizationId={organizationId} />
		</AsyncBoundary>
	);
}
